export default "__VITE_ASSET__Gag$hwbA__"